module.exports = __webpack_public_path__ + "static/media/JP_RS_EYELASHES01.e4e2a910.jpg";